const activeItems = (state = [], action) => {
	switch (action.type) {
		case "INITIAL_NOTIFICATIONS_RECEIVED": {
			const ids = [];
			action.notifications.forEach((item) => {
				if (item) {
					ids.push(item.id);
				}
			});
			const newState = [...ids];
			return newState;
		}

		case "ACTIVE_NOTIFICATIONS_PAGE_RECEIVED": {
			const newState = action.reset ? [] : [...state];
			action.notifications.forEach((item) => {
				if (item && !newState.includes(item.id)) {
					newState.push(item.id);
				}
			});
			return newState;
		}

		case "NOTIFICATION_BATCH_RECEIVED": {
			const newState = [...state];
			action.notifications.forEach((item) => {
				if (item) {
					if (item.remove) {
						const idx = newState.indexOf(item.id);
						if (idx > -1) newState.splice(idx, 1);
					} else {
						if (!newState.includes(item.id)) newState.push(item.id);
					}
				}
			});
			return newState;
		}

		default:
			return state;
	}
};

const activeItemsById = (state = {}, action) => {
	switch (action.type) {
		case "INITIAL_NOTIFICATIONS_RECEIVED": {
			return action.notifications.reduce((acc, not) => {
				if (not) {
					return { ...acc, [not.id]: not };
				} else {
					return { ...acc };
				}
			}, {});
		}

		case "ACTIVE_NOTIFICATIONS_PAGE_RECEIVED": {
			const currentState = action.reset ? {} : state;
			return action.notifications.reduce((acc, not) => {
				if (not) {
					return { ...acc, [not.id]: not };
				}
				return acc;
			}, { ...currentState });
		}

		case "NOTIFICATION_BATCH_RECEIVED": {
			{
				const not = action.notifications.reduce((acc, not) => {
					if (not) {
						return { ...acc, [not.id]: not };
					} else {
						return { ...acc };
					}
				}, {});
				const updatedState = { ...state, ...not };
				const finalState = Object.fromEntries(
					Object.entries(updatedState).filter(([key, value]) => !value.remove)
				);
				return finalState;
			}
		}

		default:
			return state;
	}
};

export const initialState = {
	initial: false,
	activeItems: [],
	activeItemsById: {},
	activePagination: {
		offset: 0,
		limit: 50,
		hasMore: true,
		loading: false,
		query: "",
		pendingQuery: "",
		snapshot: ""
	}
};

const notifications = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ACTIVE_NOTIFICATIONS_QUERY":
			return {
				...state,
				activePagination: {
					...state.activePagination,
					pendingQuery: action.query
				}
			};
		case "ACTIVE_NOTIFICATIONS_PAGE_REQUESTED":
			return {
				...state,
				activePagination: {
					...state.activePagination,
					loading: true
				}
			};
		case "ACTIVE_NOTIFICATIONS_PAGE_RECEIVED":
			return {
				...state,
				initial: true,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action),
				activePagination: {
					offset: action.offset,
					limit: action.limit,
					hasMore: action.hasMore,
					loading: false,
					query: action.query,
					pendingQuery: action.query,
					snapshot: action.snapshot || ""
				}
			};
		case "ACTIVE_NOTIFICATIONS_PAGE_FAILED":
			return {
				...state,
				activePagination: {
					...state.activePagination,
					loading: false
				}
			};
		case "INITIAL_NOTIFICATIONS_RECEIVED":
			return {
				...state,
				initial: true,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action)
			};
		case "NOTIFICATION_BATCH_RECEIVED":
			return {
				...state,
				initial: false,
				activeItems: activeItems(state.activeItems, action),
				activeItemsById: activeItemsById(state.activeItemsById, action)
			};
		default:
			return state;
	}
};

export default notifications;
